<template>
  <v-app style="margin-bottom: 35px">
    <AppBar />

    <Footer />

    <v-snackbar
      v-model="error.status"
      top
      right
      color="red"
      v-show="error.msg !== ''"
    >
      <v-icon>mdi-alert-outline</v-icon> {{ error.msg }}
    </v-snackbar>

    <v-snackbar
      v-model="success.status"
      top
      right
      color="success"
      v-show="success.msg !== ''"
    >
      <v-icon>mdi-checkbox-marked-circle-outline</v-icon> {{ success.msg }}
    </v-snackbar>

    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import AppBar from './components/AppBar'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: { AppBar, Footer },
  data: () => {
    return {
      dialogMessage: true,
    }
  },

  metaInfo() {
    return {
      title: 'Giftcode VGPlay',
      link: [{ rel: 'icon', type: 'image/x-icon', href: '/vgp.ico' }],
    }
  },

  computed: {
    ...mapGetters(['MESSAGE_ERROR', 'MESSAGE_SUCCESS']),
    error() {
      return this.$store.getters.MESSAGE_ERROR
    },
    success() {
      return this.$store.getters.MESSAGE_SUCCESS
    },
  },
}
</script>

<style>
@font-face {
  font-family: 'LD';
  src: local('LD'),
    url(../src/assets/fonts/LexendDeca-Regular.ttf) format('truetype');
}
@font-face {
  font-family: 'Material Design Icons';
  font-style: normal;
  font-weight: 400;
  src: local('Material Design Icons'),
    url(../src/assets/fonts/MaterialIcons-Regular.eot) format('eot');
}
</style>
